export enum Trace {
    Debug = 1,
    Info = 2,
    Warning = 4,
    Error = 8,
    Success = 16,
}
